import React, { memo } from 'react';
import { FaEye, FaTrash, FaSpinner } from 'react-icons/fa';
import { OrderActionsSectionProps } from './OrderRowTypes';
import {
  getStatusText,
  getStatusSimpleClass,
  formatOrderDate,
  formatOrderTime,
} from '../../../utils/orderUtils';

export const OrderActionsSection = memo<OrderActionsSectionProps>(
  ({ order, onViewOrder, onDeleteOrder }) => (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 lg:gap-6">
      <div className="flex flex-col items-start sm:items-center gap-1">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Durum</span>
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusSimpleClass(order.status)}`}
        >
          {getStatusText(order.status)}
        </span>
      </div>

      <div className="flex flex-col items-start sm:items-center gap-1 min-w-0">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Tarih</span>
        <div className="text-xs text-gray-600">{formatOrderDate(order.created_at)}</div>
        <div className="text-xs text-gray-500">{formatOrderTime(order.created_at)}</div>
      </div>

      <div className="flex flex-col items-start sm:items-center gap-1">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">İşlemler</span>
        <div className="flex gap-2">
          <button
            onClick={() => onViewOrder(order.id)}
            className="flex items-center gap-1 px-3 py-1.5 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors text-xs font-medium"
            title="Detayları Görüntüle"
          >
            <FaEye className="text-xs" />
            <span className="hidden sm:inline">Detay</span>
          </button>
          <button
            onClick={() => onDeleteOrder(order.id)}
            disabled={order.deleting}
            className="flex items-center gap-1 px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-colors text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            title="Sil"
          >
            {order.deleting ? (
              <FaSpinner className="text-xs animate-spin" />
            ) : (
              <FaTrash className="text-xs" />
            )}
            <span className="hidden sm:inline">{order.deleting ? 'Siliniyor...' : 'Sil'}</span>
          </button>
        </div>
      </div>
    </div>
  )
);

OrderActionsSection.displayName = 'OrderActionsSection';
